import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import { NEW_ACCOUNT_VALUE } from "app/pages/sales-intelligence/domain/crm-integration/constants/account";

import type { AccountExportPreview, AccountsExportState } from "../types";
import { sortAccountsPreview } from "../utils/sortAccountsPreview";

import * as ac from "./action-creators";

const INITIAL_STATE: AccountsExportState = {
    phase: { type: "idle" },
    integration: null,
    leadsType: null,
    listId: undefined,
    countries: [],
    preview: [],
    isFetchingPreview: false,
};

const preSelectAccountId = (item: AccountExportPreview): string => {
    if (item.matchedCompanies.length > 0) {
        return item.matchedCompanies[0].id;
    }

    return NEW_ACCOUNT_VALUE;
};

const accountsCrmExportReducer = createReducer<AccountsExportState, ActionType<typeof ac>>(INITIAL_STATE)
    .handleAction(ac.initAccountsExport, (state, { payload }) => ({
        ...state,
        integration: payload.integration,
        leadsType: payload.leadsType,
        countries: payload.countries,
        listId: payload.listId,
    }))
    .handleAction(ac.setAccountsExportPhase, (state, { payload }) => ({
        ...state,
        phase: payload,
    }))
    .handleAction(ac.fetchAccountsPreviewAsync.request, (state) => ({
        ...state,
        isFetchingPreview: true,
    }))
    .handleAction(ac.fetchAccountsPreviewAsync.success, (state, { payload }) => ({
        ...state,
        isFetchingPreview: false,
        preview: sortAccountsPreview(payload.map((item) => ({ ...item, accountId: preSelectAccountId(item) }))),
    }))
    .handleAction(ac.fetchAccountsPreviewAsync.failure, (state) => ({
        ...state,
        isFetchingPreview: false,
    }))
    .handleAction(ac.accountPreviewChanged, (state, { payload }) => ({
        ...state,
        preview: state.preview.map((item) => (item.domain === payload.domain ? payload : item)),
    }))
    .handleAction(ac.accountPreviewDeleted, (state, { payload }) => ({
        ...state,
        preview: state.preview.filter((item) => item.domain !== payload),
    }))
    .handleAction(ac.applyBulkAccountsSelection, (state, { payload }) => ({
        ...state,
        preview: state.preview.map((item) => ({
            ...item,
            accountId:
                payload === "create-all-new"
                    ? NEW_ACCOUNT_VALUE
                    : item.matchedCompanies.length > 0
                      ? item.matchedCompanies[0].id
                      : NEW_ACCOUNT_VALUE,
        })),
    }))
    .handleAction(ac.resetAccountsExport, () => INITIAL_STATE);

export default accountsCrmExportReducer;
